import { generateUniqueId, INIT_ENCOUNTER_NAME, COLOR_GREEN, COLOR_RED} from '../../constants'
import { useImportedPlayers } from '../../../../../providers/ImportedPlayersProvider';
import { useHomebrewProvider } from '../../../../../providers/HomebrewProvider';
import 'react-tabs/style/react-tabs.css';
import { useEffect, useState } from 'react';
import SpellBlock from '../Statblock/PopupBlocks/SpellBlock';
import ConditionBlock from "../Statblock/PopupBlocks/ConditionBlock";
import ImportList from "./ImportList"
import Book from './Books/Book'
import SearchTabMonsterItem from './SearchTabMonsterItem';

const SearchTab = ({tabSelectedIndex, displayedItems, setCurrentEncounter, encounterGuid, searchTerm, setSearchSelectedCreature, setPinnedCount, socket}) => {    
    
    const {removeFromImportList} = useImportedPlayers();
    const {removeFromHomebrewList} = useHomebrewProvider();
    const [xClicked, setXClicked] = useState({click: false, index: undefined});
    const [shake, setShake] = useState(undefined);

    useEffect(() => {
        if(shake) {
            setTimeout(() => {
                setShake(undefined)
            }, 2000)
        }
    }, [shake])

    useEffect(() => {
        if(xClicked.click) {
            setTimeout(() => {
                setXClicked({click: false, index: undefined})
            }, 2000)
        }

    }, [xClicked])

    const handleSearchSelectCreature = async (creature, action, event=undefined, count=1) => {
        event?.stopPropagation();

        if(creature?.creatureGuid !== undefined) {
            if(action === "add") {
                // Group Added
                let groupIndex = 0;
                let groupGuid = null;
                if(count !== 1) {
                    groupGuid = generateUniqueId()
                }
                    
                while(groupIndex !== count) {
                    groupIndex++; // Count up         
                    let c = {...creature};
                    if(groupGuid) {
                        c.groupGuid = groupGuid // Can be null if just one
                        c.name = c.name + " " + groupIndex
                    }

                    handleSelectCreature(c, action)  
                }

            } else if(action === "select" ) {
                handleSelectCreature(creature, action)            
            }
        }
    };

    const handleSelectCreature = (creature, action) => {
        if(action === "add") {
            setCurrentEncounter(prev => {
                // set to prev.encounterGuid, passed in encounterGuid could be stale
                let eGuid = prev.encounterGuid;
                let newCreature = {...creature, creatureGuid: generateUniqueId(), encounterGuid: eGuid}
                if(prev.creatures.length === 0 && prev.encounterName === INIT_ENCOUNTER_NAME) {
                    socket.emit("newEncounter", eGuid, '', prev.folder_dir)
                }

                // If there are no creatures in this list, then create the encounter in the database and add to it
                socket.emit("addCreatureToEncounter", newCreature)
              
                // Return the updated state with the new creature added
                return {
                  ...prev,
                  creatures: [...prev.creatures, newCreature]
                };
            });           
        } else if(action === "select") {
            if(creature.dmb_homebrew_guid) {
                setSearchSelectedCreature({...creature});
            } else {
                let newGuid = generateUniqueId();
                setSearchSelectedCreature({...creature, creatureGuid: newGuid});
            }
        }

    };

    const handleXClick = async (c, index) => {
        let handled = c?.dnd_b_player_id 
                        ? await removeFromImportList(c, index)
                        : await removeFromHomebrewList(c, index)

        if(handled) { 
            setXClicked({click: true, index})
        }
    }

    const colors = {
        "enemy": COLOR_RED,
        "neutral": '#999999',
        "ally": COLOR_GREEN,
        "pet": COLOR_GREEN
    }

    if (tabSelectedIndex === 2) {
        return <ImportList displayedItems={displayedItems} encounterGuid={encounterGuid} searchTerm={searchTerm} handleSearchSelectCreature={handleSearchSelectCreature} xClicked={xClicked} handleXClick={handleXClick} colors={colors} shake={shake}/>
    }

    if (tabSelectedIndex === 3) {
        return (
            <>
                {displayedItems.length > 0 ? ( displayedItems?.map((spell) => (
                    <li className={`spellListItem`} key={spell.name + spell.source}>
                        <SpellBlock spell={spell} enableCollapse={true}/>
                    </li>
                ))) : (
                    <div className='searchListCreatureContainer noCreaturesFound'>No Spells found...</div>
                )}
            </>
        );
    }

    if (tabSelectedIndex === 4) {
        return (
            <>
                {displayedItems.length > 0 ? ( displayedItems?.map((condition) => (
                    <li className={`spellListItem`} key={condition.name + condition.source}>
                        <ConditionBlock condition={condition} enableCollapse={true}/>
                    </li>
                ))) : (
                    <div className='searchListCreatureContainer noCreaturesFound'>No Conditions found...</div>
                )}
            </>
        );
    }


    // Books
    if (tabSelectedIndex === 5) {
        // let bookArray = displayedItems;
        let adventureNames = displayedItems;
        return (
            <>
                {adventureNames.map(bookInfo => ( 
                    <li className='bookListItem' key={bookInfo.id + "outer"}>
                        <Book bookinfo={bookInfo} handleSearchSelectCreature={handleSearchSelectCreature} setPinnedCount={setPinnedCount} socket={socket}/>
                    </li>
                ))}
            
            </>
        );
    }
    //tabSelectedIndex === 0 || 1
    return (
        <>
            {displayedItems.length > 0 ? ( displayedItems?.map((creature, index) => (
                <SearchTabMonsterItem key={creature.name + creature.sourceShort} creature={creature} index={index} handleSearchSelectCreature={handleSearchSelectCreature} searchTerm={searchTerm} />
            ))) : (
                <div className='searchListCreatureContainer noCreaturesFound'>No creatures found...</div>
            )}
        </>
    );
}

export default SearchTab;